<div class=" ktbl-container-border container-size">
  <h1 mat-dialog-title>Wechseln der Gebäudeklasse/Tierkategorie</h1>
  <hr />
  <mat-dialog-content>
    <b>
      Sind sie sicher, dass die Gebäudeklasse/Tierkategorie wechseln wollen?
    </b>
    <br />
    <br />
    Alle vorhergehenden gemachten Eingaben werden verworfen.
    <hr />

    <div class="ktbl-button-container">
      <div class="ktbl-button-container-left">
        <!--Absichtlich leerer Container. Wenn doch mal ein Button links sein soll-->
      </div>

      <div class="ktbl-button-container-right">
        <button class="ktbl-button-sekundaer ktbl-button-width-m " type="button" [mat-dialog-close]="1" tabindex="-1">
          Ja
        </button>

        <button class="ktbl-button-primaer ktbl-button-width-m " type="button" [mat-dialog-close]="0" tabindex="-1">
          Nein
        </button>
      </div>
    </div>
  </mat-dialog-content>
</div>